module.exports = __webpack_public_path__ + "static/img/industry_health.9241c9e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/site/industry_health.jpg
// module id = vTlt
// module chunks = 0